import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


type Props={
    placeholder:string,
    onClick?:()=>void,
    onBlur?:()=>void,
    onChange:(value: string)=>void, 
}

const SearchInput = (props:Props) => {
 
    
    return (
        <div className={`w-full relative `} >
            <div className="absolute top-2 left-3">
                <FontAwesomeIcon className="w-5 h-5 search-icon text-light-gray " icon={faMagnifyingGlass} />
            </div>
            <input 
            className={`input-icons-div w-full h-9 pr-[13px] pl-[45px]
             py-2 rounded-lg border border-light-border justify-start items-center gap-2.5 inline-flex `} 
            type="search" placeholder={props.placeholder}
            onClick={props.onClick && props.onClick} onBlur={props.onBlur && props.onBlur}
            onChange={(event)=>props.onChange(event.target.value)}
            />
        </div>
    );
}
export default SearchInput;